module.exports = "/_next/static/images/6cd7ce7a491966d6a778f0fa7e830054-purple-box-icon.svg";